import { render, staticRenderFns } from "./PrescriptionList.vue?vue&type=template&id=6ffe8c68&scoped=true"
import script from "./PrescriptionList.vue?vue&type=script&lang=js"
export * from "./PrescriptionList.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionList.vue?vue&type=style&index=0&id=6ffe8c68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe8c68",
  null
  
)

export default component.exports